export default {
    state: {
        depositId: null,
        proformTotal: 0,
        hasAnnexes: 0
    },

    getters: {},

    mutations: {
        updateProformTotal(state, total){
            state.proformTotal = total
        },
        updateHasAnnexes(state, value){
            state.hasAnnexes = value
        }

    },

    actions: {}
}